import { type GeoMapColor } from '@editor2/types/pageElements';
import { type FC, useEffect, useState } from 'react';
import Select from 'react-select';

interface Props {
	options: any;
	value: GeoMapColor;
	row: number;
	col: number;
	onSelectCellChange: (_) => void;
}

const GroupSelect: FC<Props> = (props) => {
	const { options, value, row, col, onSelectCellChange } = props;

	const [valueSelected, setValueSelected] = useState({ label: value?.name, value: value?.id });

	const onChange = (option) => {
		setValueSelected(option);
		onSelectCellChange({ row, col, value: option.value });
	};

	useEffect(() => {
		if (valueSelected?.label !== value?.name) {
			setValueSelected({ label: value?.name, value: value?.id });
		}
	}, [value]);

	return (
		<Select
			className="rangeCell"
			key={`${valueSelected.label}_${valueSelected.value}`}
			value={valueSelected}
			onChange={(option) => onChange(option)}
			options={options}
			menuPortalTarget={document.body}
			styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
		/>
	);
};

export default GroupSelect;
